import React, { useContext, useState } from "react";
import { get, isEmpty, find, last } from "lodash";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldInput,
  FieldButtonGroup,
  LoaderWrapper,
  DeleteWarning,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  yesNoOptions,
  FORM_PLACEHOLDERS,
  getFormattedPhone,
  getAdvancedPathWithParam,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setManagePlanFlow,
  setManagePageLevelData,
  savePlanDetailsAction,
} from "../../../contexts";
import { useRouterParams, useRequest } from "../../../abstracts";
import {
  deleteTransfer,
  deleteTrustee,
  getTrustee,
  saveTrustee,
} from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const initialValues = {
  trusteePlanMapId: 0,
  workPhoneNumber: null,
  website: null,
  level: 2,
  tenantId: 2,
  addToMaster: false,
};

const AddTrusteeContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [newFlow] = useState("");
  const { planId, flow, trusteeId } = useRouterParams();
  const formName = managePlanFormNames.ADD_TRUSTEE_MANAGE_PLAN;
  const fields = formFields[formName];
  const DeleteToastMessage = "You are attempting to delete a trustee.";
  const DeleteToastMessageHead = "Delete Trustee?";
  const [errorMsg, setErrorMsg] = useState("");
  const [showWarning, setShowWarning] = useState(false);

  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(0);

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleConfirmClick1 = () => {
    deleteTrustee(parseInt(trusteeId)).then((response) => {
      if (response.isSuccessful) {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: `Data deleted successfully`,
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.TRUSTEE,
            pathParam: [flow, planId],
          })
        );
      } else {
        var x = response.errorMessages;
        if (
          //x[0].controlName == null &&
          x[0].errorCode !== null &&
          x[0].message !== null
        ) {
          setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
          setIsModalOpen(true);
        }
      }
    });
  };
  const intTrusteeId = parseInt(trusteeId, 10);

  const { response: trustee, loading: loading } = useRequest({
    method: getTrustee,
    payload: intTrusteeId,
    defaultResponse: [],
  });
  const formValues = get(trustee, "trustee", {});

  // const formValues =
  //   find(trusteeListData, {
  //     id: intTrusteeId,
  //   }) || {};
  const isAddedToMaster = formValues[fields.addToMaster];

  // const onDeleteClick = ({ setFieldError, setFieldTouched }) => {
  //   deleteTrustee(parseInt(trusteeId)).then((response) => {
  //     if (response.isSuccessful) {
  //       dispatch(
  //         setManagePlanToastInfo({
  //           showToast: true,
  //           toastMessage: `Data deleted successfully`,
  //         })
  //       );
  //       history.push(
  //         getPathWithParam({
  //           path: MANAGE_PLAN_ROUTES.TRUSTEE,
  //           pathParam: [flow, planId],
  //         })
  //       );
  //     } else {
  //       for (var i = 0; i < response.errorMessages.length; i++) {
  //         var _ = response.errorMessages[i];
  //         setFieldTouched(_.controlName, true);
  //         setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
  //       }
  //     }
  //   });
  // };

  const getDataForSave = (values) => {
    const { trusteeCompanyName } = values;
    const updatedValues = {
      id: get(values, "id", 0),
      trusteePlanMapId: get(values, "advisorPlanMapId", 0),
      planId: parseInt(planId),
      tenantId: get(values, "tenantId", 0),
      trusteeCompanyName: trusteeCompanyName || undefined,
      trusteePlanMapId: get(formValues, "trusteePlanMapId", 0),
      contactDetails: {
        mobilePhoneNumber: values.mobilePhoneNumber || undefined,
        workPhoneNumber: values.workPhoneNumber || undefined,
        email: values.email || undefined,
        website: values.website || undefined,
      },
    };
    if (isEmpty(formValues)) {
      return updatedValues;
    }

    return updatedValues;
  };

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    const { history } = props;

    saveTrustee(getDataForSave(values)).then((response) => {
      if (response.isSuccessful) {
        // const newPlanId = get(response, "id");
        const newPlanId = get(response, "planId"); //get(last(get(response, "trustees", [])), "plan.id");
        dispatch(
          setManagePlanFlow({
            planId: planId,
          })
        );
        dispatch(
          setManagePageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.TRUSTEE,
            pathParam: [flow, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      } else {
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.TRUSTEE,
        pathParam: [flow, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.TRUSTEE,
        pathParam: [flow, planId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [!isAddedToMaster && FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_TRUSTEE,
            pathParam: [FLOW_TYPES.SAVE, planId, trusteeId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [!isAddedToMaster && FLOW_TYPES.EDIT],
    //   icon: faPencilAlt,
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_PLAN_ROUTES.ADD_TRUSTEE,
    //         pathParam: [FLOW_TYPES.SAVE, planId, trusteeId],
    //       })
    //     ),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];

  // const formInitialValues = get(state, managePlanFormNames.ADD_TRUSTEE_MANAGE_PLAN, {});
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const layoutHeader = trusteeId && "Trustee";
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        trusteePlanMapId: get(formValues, "trusteePlanMapId", 0),
        email: get(formValues, "contactDetails.email", ""),
        mobilePhoneNumber: get(
          formValues,
          "contactDetails.mobilePhoneNumber",
          ""
        ),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setSubmitting,
        ...rest
      }) => {
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManagePlanLayout
              buttons={buttons}
              pageFlow={newFlow || flow}
              layoutHeader={layoutHeader}
            >
              <LoaderWrapper isLoading={loading}>
                <p className="plan-sub-heading">
                  {trusteeId ? "Edit Trustee" : "Add New Trustee"}
                </p>
                <Row>
                  <Col md="4">
                    <Field
                      size="md"
                      name={fields.trusteeCompanyName}
                      label={"Trustee Company Name"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.trusteeCompanyName]}
                      onChange={handleChange}
                      disabled={isAddedToMaster || (isEdit && !isSave)}
                      component={FieldInput}
                      isRequired
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <Field
                      size="md"
                      name={fields.email}
                      label={"Email"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.email]}
                      onChange={handleChange}
                      disabled={isAddedToMaster || (isEdit && !isSave)}
                      component={FieldInput}
                      isRequired
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      size="md"
                      name={fields.mobilePhoneNumber}
                      label={"Phone Number"}
                      type="text"
                      autoComplete="off"
                      onChange={handleChange}
                      disabled={isAddedToMaster || (isEdit && !isSave)}
                      component={FieldInput}
                      isRequired
                      maxLength="12"
                      value={getFormattedPhone(
                        values[fields.mobilePhoneNumber]
                      )}
                      placeholder={FORM_PLACEHOLDERS.phone}
                    />
                  </Col>
                </Row>
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick1}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </LoaderWrapper>
            </ManagePlanLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddTrusteeContainer;
